import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthServiceService } from '../../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-subadmin-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss'],
})
export class SubAdminVoucherComponent implements OnInit {
  @ViewChild('UploadFileModal') uploadFileModal: TemplateRef<any>;

  vouchers: any;
  totalItems: number = 0;
  totalPages: number = 0;
  currentPage: number = 1;
  order_detail: any;
  imgUrl = environment.ImageUrl;
  voucher: any = {
    appUserReferralHistories: [],
  };
  voucherId: any = null;
  voucherValue: number = 0;
  termsAndConditions: string = '';
  outletCode: string = '';
  minimumSpending: number = 0;
  onlyReferral: boolean = false;

  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        // 'heading',
        // '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.auth
      .shop_business_fetch({
        category: 'voucher',
        page: this.currentPage,
        limit: 12
      })
      .subscribe(
        (response: any) => {
          this.vouchers = response.body.data;
          this.totalItems = response.body.totalItems;
          this.totalPages = response.body.totalPages;
          this.currentPage = response.body.currentPage;
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  previousPage() {
    this.currentPage--;
    this.initData();
  }

  nextPage() {
    this.currentPage++;
    this.initData();
  }

  openModal(content: any) {
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });

    this.voucherId = null;
    this.voucherValue = 0;
    this.termsAndConditions = '';
    this.outletCode = '';
    this.minimumSpending = 0;
    this.onlyReferral = false;
  }

  handleEdit(data: any) {
    this.openModal(this.uploadFileModal);
    this.voucherId = data.id;
    this.voucherValue = data.discount;
    this.termsAndConditions = data.termsAndConditions;
    this.outletCode = data.outletCode;
    this.minimumSpending = data.minimumSpending;
    this.onlyReferral = data.onlyReferral;
  }

  onEditorChange = (event: any) =>
    (this.termsAndConditions = event.editor.getData());

  fileUpload: File | null = null;
  thumbnail: string | null = null;
  onFileSelected(event: any) {
    this.fileUpload = null;
    this.thumbnail = null;
    const file: File = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        this.fileUpload = file;
        // const reader = new FileReader();
        // reader.onload = (e: any) => {
        //   console.log('Data URL:', e.target.result);
        // };
        this.toastr.success(`Selected image file: ${file.name}`);
      } else {
        this.toastr.warning('Please select an image file');
      }
    } else {
      this.toastr.warning('No file selected');
    }
  }

  isUploading: boolean = false;
  handleUpload() {
    if (this.fileUpload == null && !this.voucherId) {
      this.toastr.warning('No file selected');
      return;
    }

    if (this.voucherValue < 1) {
      this.toastr.warning('Voucher value is required');
      return;
    }

    const payload = new FormData();
    if (this.voucherId) {
      payload.append('id', this.voucherId.toString());
    }
    if (this.fileUpload) {
      payload.append('file', this.fileUpload as Blob);
    }
    payload.append('category', 'voucher');
    payload.append('cashbackValue', this.voucherValue.toString());
    payload.append('termsAndConditions', this.termsAndConditions);
    payload.append('outletCode', this.outletCode);
    payload.append('onlyReferral', this.onlyReferral.toString());
    if (this.minimumSpending >= 0) {
      payload.append('minimumSpending', this.minimumSpending.toString());
    } else {
      this.toastr.error("Minimum spending cannot be less than 0");
      return false
    }
    this.isUploading = true;

    this.auth.shop_business_store(payload).subscribe(
      (response: any) => {
        this.modalService.dismissAll();
        this.toastr.success('Uploaded successfully');
        this.isUploading = false;
        this.initData();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.isUploading = false;
      }
    );
  }

  handleDelete(id: any) {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to delete this voucher?',
      })
      .then((res: any) => {
        if (res.isConfirmed) {
          this.auth.shop_business_delete(id).subscribe(
            (response: any) => {
              this.toastr.success('Deleted successfully');
              this.initData();
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
        }
      });
  }

  handleView(id: any) {
    this.auth.shop_business_view(id).subscribe(
      (response: any) => {
        this.toastr.success('Viewed successfully');
        this.voucher = response.body;
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }
}
